import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NotificationsHelperService {
  unreadBusinessNotificationsCountChange = new Subject<boolean>();
  unreadNotificationsCountChange = new Subject<boolean>();
  unreadReservationsNotificationsCountChange = new Subject<boolean>();
  unreadGiftsNotificationsCountChange = new Subject<boolean>();
  newReservationNotification= new Subject<boolean>();

  constructor() {}

  clickOnUnreadNotification(): void {
    this.unreadNotificationsCountChange.next(true);
  }
  clickOnBusinessUnreadNotification(): void {
    this.unreadBusinessNotificationsCountChange.next(true);
  }
  clickOnReservationUnreadNotification(): void {
    this.unreadReservationsNotificationsCountChange.next(true);
  }
  recievedGiftsNotification(): void {
    this.unreadGiftsNotificationsCountChange.next(true);
  }
  recievedReservationsNotification(): void {
    this.newReservationNotification.next(true);
  }
}
